import { createFileRoute } from "@tanstack/react-router";

import { AdminPlatformSettings } from "@/features/admin/components/AdminPlatformSettings";

/**
 * Platform Settings route — CRUD per Pricing models + Usage tier plans.
 * Mounted under the Admin shell (gated by ``useHasCapability("admin")``).
 */
export const Route = createFileRoute("/_authed/_modal/admin/platform-settings")({
  component: AdminPlatformSettings,
});
